"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetAdAccountMembersResponseToJSON = exports.GetAdAccountMembersResponseFromJSONTyped = exports.GetAdAccountMembersResponseFromJSON = exports.instanceOfGetAdAccountMembersResponse = void 0;
var runtime_1 = require("../runtime");
var AdAccountMemberResponse_1 = require("./AdAccountMemberResponse");
var Paging_1 = require("./Paging");
/**
 * Check if a given object implements the GetAdAccountMembersResponse interface.
 */
function instanceOfGetAdAccountMembersResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfGetAdAccountMembersResponse = instanceOfGetAdAccountMembersResponse;
function GetAdAccountMembersResponseFromJSON(json) {
    return GetAdAccountMembersResponseFromJSONTyped(json, false);
}
exports.GetAdAccountMembersResponseFromJSON = GetAdAccountMembersResponseFromJSON;
function GetAdAccountMembersResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'paging': !(0, runtime_1.exists)(json, 'paging') ? undefined : (0, Paging_1.PagingFromJSON)(json['paging']),
        'adAccountMembers': !(0, runtime_1.exists)(json, 'ad_account_members') ? undefined : (json['ad_account_members'].map(AdAccountMemberResponse_1.AdAccountMemberResponseFromJSON)),
    };
}
exports.GetAdAccountMembersResponseFromJSONTyped = GetAdAccountMembersResponseFromJSONTyped;
function GetAdAccountMembersResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'paging': (0, Paging_1.PagingToJSON)(value.paging),
        'ad_account_members': value.adAccountMembers === undefined ? undefined : (value.adAccountMembers.map(AdAccountMemberResponse_1.AdAccountMemberResponseToJSON)),
    };
}
exports.GetAdAccountMembersResponseToJSON = GetAdAccountMembersResponseToJSON;
